import { STATUS_REASON } from './Device.utils.ValueSets';

/* This is a way to access environment variables in a React app. */
const { REACT_APP_DOMAIN } = process.env;

/**
 * * It takes a set of values and returns a Device resource in FHIR format
 * @param values - The values from the form
 * @returns A deviceData object.
 */
export function mDevice(values) {
  const deviceData = {
    resourceType: 'Device',
    deviceName: [
      {
        name: values.deviceName_name,
        type: values.deviceName_type,
      },
    ],
  };

  if (values.id !== '' && values.id !== undefined) {
    deviceData.id = values.id;
  }

  if (values.type !== '' && values.type !== undefined) {
    deviceData.type = [
      {
        text: values.type,
        system: `${REACT_APP_DOMAIN}/fhir/NamingSystem/lifeline-device-type`,
      },
    ];
  }

  if (values.status !== '' && values.status !== undefined) {
    deviceData.status = values.status;
  }

  if (values.statusReason !== '' && values.statusReason !== undefined) {
    deviceData.statusReason = {
      coding: [
        {
          system: 'http://terminology.hl7.org/CodeSystem/device-status-reason',
          code: values.statusReason,
          display: STATUS_REASON.values.find((el) => el.code === values.statusReason).display,
        },
      ],
    };
  }

  if (values.deviceName_name !== '' && values.deviceName_type !== '') {
    deviceData.deviceName = [
      {
        name: values.deviceName_name,
        type: values.deviceName_type,
      },
    ];
  }

  if (values.manufacturer !== '' && values.manufacturer !== undefined) {
    deviceData.manufacturer = values.manufacturer;
  }

  if (values.serialNumber !== '' && values.serialNumber !== undefined) {
    deviceData.serialNumber = values.serialNumber;
  }

  if (values.patient !== '' && values.patient !== undefined) {
    deviceData.patient = {
      reference: `Patient/${values.patient}`,
      type: 'Patient',
    };
  }

  if (values.location !== '' && values.location !== undefined) {
    deviceData.location = {
      reference: `Location/${values.location}`,
      type: 'Location',
    };
  }

  if (values.url !== '' && values.url !== undefined) {
    deviceData.url = values.url;
  }

  if (
    (values.maxslot !== '' && values.maxslot !== undefined) ||
    (values.notification !== '' && values.notification !== undefined) ||
    (values.notificationSound !== '' && values.notificationSound !== undefined)
  ) {
    deviceData.extension = [];
    deviceData.extension.push({
      url: `${REACT_APP_DOMAIN}/StructureDefinition/patient-lifeline-monitor-config`,
      extension: [
        {
          url: 'maxslot',
          valueInteger: values.maxslot,
        },
        {
          url: 'notification',
          valueBoolean: values.notification,
        },
        {
          url: 'notificationSound',
          valueString: values.notificationSound,
        },
      ]
    });
  }

  let hasPatient = false;

  const lifelinePatientExtension = [];

  for (let i = 0; i < 10; i += 1) {
    if (
      values[`slot${i + 1}`] !== '' &&
      values[`slot${i + 1}`] !== undefined
    ) {
      hasPatient = true;
      lifelinePatientExtension.push({
        url: `${REACT_APP_DOMAIN}/StructureDefinition/patient-lifeline-monitor-patient`,
        extension: [
          {
            url: 'position',
            valueInteger: i + 1,
          },
          {
            url: 'patient',
            valueReference: {
              reference: `Patient/${values[`slot${i + 1}`]}`,
              type: 'Patient',
            },
          },
        ],
      });
    }
  }

  if (hasPatient) {
    if (!Array.isArray(deviceData.extension)) {
      deviceData.extension = [];
    }

    deviceData.extension.push(...lifelinePatientExtension);
  }

  let hasMarker = false;

  const mybeshiePostionExtension = [];

  if (values.markers) {
    const markerEntries = Object.entries(values.markers);

    markerEntries.forEach(([key, value]) => {
      mybeshiePostionExtension.push({
        url: `${REACT_APP_DOMAIN}/StructureDefinition/device-mybeshie-position-marker`,
        extension: [
          {
            url: 'name',
            valueString: key,
          },
          {
            url: 'position_x',
            valueDecimal: value.positionX,
          },
          {
            url: 'position_y',
            valueDecimal: value.positionY,
          },
          {
            url: 'orientation',
            valueDecimal: value.orientation,
          },
        ],
      });
      hasMarker = true;
    });
  }

  if (hasMarker) {
    if (!Array.isArray(deviceData.extension)) {
      deviceData.extension = [];
    }

    deviceData.extension.push(...mybeshiePostionExtension);
  }

  if (values.mybeshieStep !== '' && values.mybeshieStep !== undefined) {
    if (!Array.isArray(deviceData.extension)) {
      deviceData.extension = [];
    }
    deviceData.extension.push({
      url: `${REACT_APP_DOMAIN}/StructureDefinition/device-mybeshie-step`,
      valueInteger: values.mybeshieStep,
    });
  }

  return deviceData;
}
